var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative fill-height gap-0"},[_c('div',[_c('div',{staticClass:"layout-header"},[_vm._t("header")],2),_c('div',{staticClass:"layout-body mb-20"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }